import React, { useState } from 'react';
import useCreditWarningStore from '../../store/credits/useCreditWarningStore';
import CreditsBalanceModal from './index';
import BuyMoreCreditsModal from '../BillingOverviewPlanInfo/BuyMoreCreditsModal';

const CreditsBalanceModalContainer = () => {
  const { isOpen, closeModal } = useCreditWarningStore();
  const [isBuyMoreOpen, setIsBuyMoreOpen] = useState(false);

  const handleOpenBuyMore = () => {
    closeModal();
    setIsBuyMoreOpen(true);
  };

  return (
    <>
      <CreditsBalanceModal open={isOpen} handleClose={closeModal} onBuyMore={handleOpenBuyMore} />
      <BuyMoreCreditsModal open={isBuyMoreOpen} onClose={() => setIsBuyMoreOpen(false)} />
    </>
  );
};

export default CreditsBalanceModalContainer;
